import { identity, omit, pickBy } from 'lodash';

import UseIgnoreUndefinedObject from './useIgnoreUndefinedObject';
import { appApi } from 'configs/variables';
import axios from 'axios';

export default function useHttpClient() {
  const { remove } = UseIgnoreUndefinedObject();
  const getParse = localStorage.getItem('user-store') || null;
  const { accessAuthen = {} } = JSON.parse(getParse);

  const https = (em) => {
    const statusCode = em?.statusCode || em?.status_code;

    // for POST,PATCH,DELETE method services using golang
    if (!!em?.message && em?.message?.includes('success')) {
      return Promise.resolve(em);
    }

    // for GET method services using golang
    if ((!statusCode && !!em?.data) || (!statusCode && !!em?.id)) {
      return Promise.resolve(em);
    }

    if (em?.length > 0) {
      return Promise.resolve(em);
    }

    if ([200, 201].includes(statusCode)) {
      return Promise.resolve(em);
    }

    return Promise.reject(em?.message || 400);
  };

  const headers = {
    Authorization: accessAuthen.access_token,
    'Content-Type': 'application/json',
  };

  const urls = (url, params = null) => {
    let endpoints = url.startsWith('http') ? url : appApi + url;
    if (params) {
      const prs = pickBy(params, identity);
      const queryParams = new URLSearchParams(prs).toString();
      endpoints = endpoints + `?${queryParams}`;
    }
    return endpoints;
  };

  const bodies = (payload, { ignoreEmpty }) => JSON.stringify(ignoreEmpty ? remove(payload) : payload);

  const get = async (options) => {
    const fn = await fetch(urls(options.url, options?.params), {
      headers,
      method: 'GET',
      ...omit(options, ['url']),
    }).then((res) => res.json());

    return https(fn);
  };

  const mutate = async (options, methods) => {
    const ignoreEmpty = !options?.acceptEmpty;
    const fn = await fetch(urls(options.url, options?.params), {
      headers,
      method: methods,
      body: bodies(options.payload, { ignoreEmpty }),
    }).then((res) => {
      const responseType = options?.responseType || 'json';
      if (responseType === 'blob') {
        return res.blob();
      } else {
        return res.json();
      }
    });

    if (options?.responseType === 'blob') {
      return Promise.resolve(fn);
    } else {
      return https(fn);
    }
  };

  const deletes = async (options) => {
    const fn = await fetch(urls(options.url, options?.params), {
      headers,
      method: 'DELETE',
    }).then((res) => res.json());

    return https(fn);
  };

  const directive = async (props) => {
    const options = {
      ...props,
      data: props?.body || {},
    };

    const response = await axios(options);
    return response.data;
  };

  // payload: {"type": "" as "text | file", value: "" ***type === "file" ~ blob, name: "" ***only type === "flie" }[]
  const formData = async (options) => {
    const initFormdata = new FormData();

    options.payload.forEach((ss) => {
      if (ss.type === 'file') {
        initFormdata.append('file', ss.value, ss.name);
      } else {
        initFormdata.append(ss.type || 'text', ss.value);
      }
    });

    const fn = await fetch(urls(options.url, options?.params), {
      headers,
      method: 'POST',
      body: initFormdata,
    }).then((res) => res.json());

    return https(fn);
  };

  return {
    token: accessAuthen?.access_token || undefined,
    get,
    post: (options) => mutate(options, 'POST'),
    put: (options) => mutate(options, 'PUT'),
    patch: (options) => mutate(options, 'PATCH'),
    deletes,
    directive,
    formData,
  };
}
